import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery, pyrotchBaseUrl } from "../axios/AxiosInstance";
import { CommentsResponse } from "../../models/Reviews";
import { AttachmentResponse } from "../../models/Reviews";

export const ReviewsApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "ReviewsApi",
  tagTypes: ["Reviews"],

  endpoints(build) {
    return {
      getReviewsData: build.query<any, number>({
        query: (projectId) => {
          return {
            url: `project-reviews/${projectId}/progress`,
            method: "GET",
          };
        },
      }),

      getProjectReviewFiles: build.query<
        AttachmentResponse,
        { projectId: number; page: number; size: number }
      >({
        query: ({ projectId, page, size }) => {
          return {
            url: `project-reviews/${projectId}/reviews-documents?page=${page}&size=${size}`,
            method: "GET",
          };
        },
      }),

      addCommentReview: build.mutation<
        any,
        {
          projectId: number;
          milestoneId: number;
          comment: string;
          files: File[];
        }
      >({
        query: ({ projectId, milestoneId, comment, files }) => {
          const formData = new FormData();
          formData.append("projectId", projectId.toString());
          formData.append("milestoneId", milestoneId.toString());
          formData.append("comment", comment);

          files.forEach((file) => {
            formData.append("files", file);
          });
          return {
            url: `project-reviews`,
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: formData,
          };
        },
      }),

      getComment: build.query<
        CommentsResponse,
        { projectId: number; page: number; size: number }
      >({
        query: ({ projectId, page, size }) => {
          return {
            url: `project-reviews/${projectId}/comments?page=${page}&size=${size}`,
            method: "GET",
          };
        },
      }),
    };
  },
});

export const {
  useLazyGetReviewsDataQuery,
  useAddCommentReviewMutation,
  useGetCommentQuery,
  useGetProjectReviewFilesQuery,
} = ReviewsApi;
